export const A11Y_TITLE = 'SoundCloud Player';
export const TRANSLATION_FEATURE = 'AriaLabels';
export const TRANSLATION_KEY = 'SoundCloudWidget_AriaLabel_TopLevel';
export const TEST_ID_PLACEHOLDER = 'SoundCloudWidget_placeholder';
